/**
 * This file has the store modules needed on all pages
 */
import Vue from 'vue';
import Vuex from 'vuex';

import currentUser from './modules/CurrentUser.js';
import columnConfig from './modules/ColumnConfig.js';
import workerTemplates from './modules/WorkerTemplates.js';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    currentUser,
    columnConfig,
    workerTemplates,
  },
});
